import { USER_ROLES } from './constants';
const dispatchConfigColumns = [
    {
        title: '_name_',
        key: 'name',
        format: 'name',
        isNested: false,
        isKey: true,
        dataSort: true,
        isRequired: true,
        canChange: {
            type: 'text',
        },
    },
    {
        title: '_order_capacity_car_',
        format: 'graph',
        key: 'order_capacity_car',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_time_capacity_car_',
        format: 'graph',
        key: 'time_capacity_car',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_order_capacity_moto_',
        key: 'order_capacity_moto',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_time_capacity_moto_',
        key: 'time_capacity_moto',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_order_capacity_bike_',
        key: 'order_capacity_bike',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_time_capacity_bike_',
        key: 'time_capacity_bike',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_order_capacity_foot_',
        key: 'order_capacity_foot',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_time_capacity_foot_',
        key: 'time_capacity_foot',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_penalty_early_pickup_',
        key: 'penalty_early_pickup',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_penalty_late_pickup_',
        key: 'penalty_late_pickup',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_penalty_early_delivery_',
        key: 'penalty_early_delivery',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_penalty_late_delivery_',
        key: 'penalty_late_delivery',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_slack_',
        key: 'slack',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_span_cost_coefficient_',
        key: 'span_cost_coefficient',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_global_span_cost_coefficient_',
        key: 'global_span_cost_coefficient',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_first_solution_strategy_',
        key: 'first_solution_strategy',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
    {
        title: '_local_search_metaheuristic_',
        key: 'local_search_metaheuristic',
        format: 'graph',
        isNested: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: 'number',
        },
    },
];

export default {
    dispatchConfigColumns: {
        [USER_ROLES.MANAGER]: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
        [USER_ROLES.ADMIN]: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
        [USER_ROLES.SUPER_ADMIN]: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
    },
    getColumns(role) {
        const list = [];
        let columns = this.dispatchConfigColumns[role] || [];
        for (let i = 0, length = columns.length; i < length; i++) {
            list.push(dispatchConfigColumns[columns[i]]);
        }
        return list;
    }
};